/* eslint-disable eqeqeq */
import React, { useState, useEffect, useMemo } from 'react';
import ActiveTaskItem from './list_items/ActiveTaskItem';
import { getRemovedOrders } from './custom_views/insta_custom_views/utils_android/CookieHelper'
import Loader from './custom_views/insta_custom_views/utils_android/LoaderAndroid';
import ufoIcon from './custom_views/insta_custom_views/insta_icons_tasks/ufo_android.png';
import CustomTaskItem from './list_items/CustomTaskItem';
import { TasksApi } from '../components_android/api/TasksApi';
import { getInstallTaskStatus, isFreshEnough } from './custom_views/insta_custom_views/utils_android/ProgressHelper';
import moment from 'moment';

// Список активных заданий считается из props.info.progress_orders при каждой отрисовке
// (а не один раз при загрузке): когда сведения о пользователе обновляются в фоне,
// только что выполненное задание сразу уходит из списка.
const buildActiveTasks = (info, youtubeTasks) => {
    const now = moment();
    const removedOrders = getRemovedOrders();
    const installTasks = [];
    if (info?.progress_orders) {
        const tasks = info.progress_orders;
        for (let index = 0; index < tasks.length; index++) {
            const element = tasks[index];
            if (!removedOrders.includes(element.bundle) && getInstallTaskStatus(element, now).active) {
                element.category = "Активно";
                installTasks.push(element);
            }
        }
        installTasks.reverse();
    }
    const tasks = installTasks.concat((youtubeTasks || []).filter((t) => isFreshEnough(t, now)));
    tasks.sort(function (a, b) {
        return new Date(b.modified) - new Date(a.modified);
    });
    return tasks;
};

// Последний загруженный список заданий-отчётов: при повторном открытии он виден
// сразу, а свежий список подменяет его, когда придёт ответ (без скелета).
const CACHE_TTL = 5 * 60 * 1000;
let activeYoutubeCache = null;

const ActiveTasks = (props) => {
    const [youtubeTasks, setYoutubeTasksState] = useState(() =>
        (activeYoutubeCache && Date.now() - activeYoutubeCache.at < CACHE_TTL ? activeYoutubeCache.list : null));
    const setYoutubeTasks = (list) => {
        activeYoutubeCache = { list: list, at: Date.now() };
        setYoutubeTasksState(list);
    };
    // запрос не удался: пустой список не запоминаем как настоящий,
    // а уже показанный (из кэша) оставляем на экране
    const keepYoutubeTasksOnError = () => {
        setYoutubeTasksState((prev) => (prev == null ? [] : prev));
    };

    useEffect(() => {
        getMyActiveYoutube();
        // свежие progress_orders: задание могло быть выполнено только что
        if (props.refreshInfo) {
            props.refreshInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMyActiveYoutube = () => {

        TasksApi.getMyActiveYoutube((responseData) => {
            if (responseData.response == 1 && responseData.proof_orders_youtube?.length > 0) {
                var activeTasks = responseData.proof_orders_youtube.filter(
                    task => task.state != 1 && task.state != -1 && task.order != null
                );
                activeTasks.forEach(element => {
                    element.is_universal = true
                });
                setYoutubeTasks(activeTasks)
            } else {
                setYoutubeTasks([])
            }
            console.log("getMyActiveYoutube success = ", responseData)
        }, (responseData) => {
            keepYoutubeTasksOnError()
            console.log("getMyActiveYoutube error = ", responseData)
        })

    };

    const allTasks = useMemo(
        () => (youtubeTasks == null ? [] : buildActiveTasks(props.info, youtubeTasks)),
        [props.info, youtubeTasks]
    );

    if (youtubeTasks == null) {
        return <Loader variant="list" />;
    }

    if (allTasks.length > 0) {
        return (
            <div className="tasks_list_items">
                {allTasks.map((item, index) => (
                    <div key={item._id != undefined ? item._id : index}>
                        {item.is_universal ?
                            <CustomTaskItem
                                onTaskClicked={props.onTaskClicked}
                                correction={item.correction}
                                isActive={true}
                                proof_order_id={item._id}
                                orderState={item.state}
                                proof_text={item.proof_text}
                                task={item.order}
                                index={index}
                                key={index}
                                isUpmob={props.isUpmob}
                                description_state={item.state == 1 ? "<p style='color : #2DB789'>Одобрено</p>" :
                                    (item.state == 2 ? "<p style='color : #E17373'>Нужно доработать</p>" :
                                        (item.state == -1 ? "<p style='color : #E17373'>Отклонено</p>" :
                                            (item.state == 0 ? "<p>На проверке</p>" :
                                                (item.state == 3 ? "<p>Выполняется</p>" : undefined))))}
                            />
                            :
                            <ActiveTaskItem
                                isUpmob={props.isUpmob}
                                backView="active"
                                onTaskClicked={props.onTaskClicked}
                                isActive={true}
                                task={item}
                                key={index}
                            />
                        }
                    </div>

                ))}

            </div>
        );
    }

    return (
        <div className="empty_tasks_container">
            <div className="display_block">
                <img className="ufo_icon" src={ufoIcon} alt="" />
                <p className="empty_tasks_text_new">На данный момент<br />активных заданий нет</p>
            </div>
        </div>
    );
};

export default ActiveTasks;
